import classNames from "classnames/bind";
import { DemographicAnswerOption } from "../../../../gql/graphql";
import { DemographicResponse } from "../types";
import styles from "../../QuizGame.module.scss";

const cx = classNames.bind(styles);

interface DemographicRadioInputProps {
  options: DemographicAnswerOption[];
  selectedOptionIds: string[];
  onChange: (response: Partial<DemographicResponse>) => void;
}

export const DemographicRadioInput = ({ options, selectedOptionIds, onChange }: DemographicRadioInputProps) => {
  const handleOptionClick = (optionId: string) => {
    onChange({ selectedOptionIds: [optionId] });
  };

  return (
    <div className={styles.answersWrapper}>
      {options.map((option) => (
        <button
          key={option.id}
          type="button"
          className={cx("answerOption", {
            selected: selectedOptionIds.includes(option.id),
          })}
          onClick={() => handleOptionClick(option.id)}
          style={{
            // borderColor: gameVisuals.themeColor,
            backgroundColor: selectedOptionIds.includes(option.id) ? "#faa61a" : "white",
            color: selectedOptionIds.includes(option.id) ? "white" : "black",
          }}
        >
          <span>{option.text}</span>
        </button>
      ))}
    </div>
  );
};
